<template>
  <div>
    <table class='table_flower' v-viewer>
      <tr>

        <th>
          流水号
        </th>
        <td width="30%">
          {{form.applicationNo}}
        </td>
        <th>
          申请业务
        </th>
        <td width="30%">
          {{form.applicationTypeText}}
          单位开户/单位信息变更
        </td>
      </tr>

      <tr>
        <th>
          单位名称
        </th>
        <td>
          {{form.enterpriseName}}
        </td>
        <th>
          社会统一信用代码
        </th>
        <td>
          {{form.enterpriseCode}}
        </td>
      </tr>
      <tr>
        <th>
          人事姓名
        </th>
        <td>
          {{form.personnelName}}
        </td>
        <th>
          人事身份证号
        </th>
        <td>
          {{form.personnelIDCardNo}}
        </td>
      </tr>
      <tr>
        <th>
          人事联系方式
        </th>
        <td colspan="3">
          {{form.personnelPhone}}
        </td>
      </tr>
      <tr>
        <th>
          是否有人力资源服务许可证
        </th>
        <td>
          {{form.hasHRPermit?'是':'否'}}
        </td>
        <th>
          是否有劳务派遣经营许可证
        </th>
        <td>
          {{form.hasLaborDispatchPermit?'是':'否'}}
        </td>
      </tr>
      <tr>
        <th>
          人事专员介绍信
        </th>
        <td>
          <div class="_link" v-for="item in form.personnelLetterGuidPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.personnelLetterGuidPreview.length<1">无</span>
        </td>
        <th>
          社会保险登记材料
        </th>
        <td>
          <div class="_link" v-for="item in form.socialInsuranceRegGuidListPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.socialInsuranceRegGuidListPreview.length<1">无</span>
        </td>
      </tr>
      <!-- 有人力资源服务许可证 -->
      <tr>
        <template v-if="form.hasHRPermit">
          <th>
            人力资源服务许可证
          </th>
          <td>
            <div class="_link" v-for="item in form.hrPermitGuidPreview" @click="handlePreview(item)" :key="item.guid">
              <Icon :type="item.name | fileType" />
              {{item.name}}
            </div>
            <span class='_noLink' v-if="form.hrPermitGuidPreview.length<1">无</span>
          </td>
        </template>
        <!-- 有劳务派遣经营许可证 -->
        <template v-if="form.hasLaborDispatchPermit">
          <th>
            劳务派遣经营许可证
          </th>
          <td>
            <div class="_link" v-for="item in form.laborDispatchPermitGuidPreview" @click="handlePreview(item)" :key="item.guid">
              <Icon :type="item.name | fileType" />
              {{item.name}}
            </div>
            <span class='_noLink' v-if="form.laborDispatchPermitGuidPreview.length<1">无</span>
          </td>
        </template>
      </tr>
      <tr>
        <th>
          其他材料
        </th>
        <td colspan="3">
          <div class="_link" v-for="item in form.otherFileGuidListPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.otherFileGuidListPreview.length<1">无</span>
        </td>
      </tr>
      <tr>
        <th>
          提交时间
        </th>
        <td>
          {{  form.submitTime }}
        </td>
        <th>
          状态
        </th>
        <td>
          {{ form.statusText}}
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: { form: Object },
  methods: {
    handlePreview(url) {
      this.$emit('handlePreview', url)
    },
  },
}
</script>